//import liraries
import { React, useState, useEffect } from "react";
import { View, Text, Dimensions, Image, FlatList, TouchableOpacity, ScrollView,} from "react-native";
import {CreateResponsiveStyle, DEVICE_SIZES, minSize, maxSize, useDeviceSize,} from "rn-responsive-styles";
import { getMPFAQS } from "../../api/maxProApi";
import HTMLRenderer from "react-html-renderer";
import Loader from "../../common/Loader";
import CHeader from "../../common/CHeader";
import CImage from "../../common/CImage";
import CText from "../../common/CText";

// create a component
const MPFaq = (props) => {
  const styles = useStyles();
  const [data, setData] = useState({ getFAQ: [] });
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [alertModalVisible, setAlertModalVisible] = useState(false);

  useEffect(() => {
    getFAQSQA();
    setAlertModalVisible(false);
  }, []);

  const getFAQSQA = () => {
    setLoading(true);
    getMPFAQS()
      .then((res) => {
        setData({ getFAQ: res });
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const toggleExpand = (index) => {
    setExpanded(index);
  };

  return (
    <>
      <CHeader
        showBack
        onPress={() => props.setActiveScreen("benefitDetails")}
        title={"FAQs"}
      />
      <View style={styles.container}>
        <View style={styles.rechargeBody}>
          <View style={styles.firstViewStyle}>
            <ScrollView
              style={{ width: "100%" }}
              showsVerticalScrollIndicator={false}
            >
              <FlatList
                data={data.getFAQ}
                style={styles.flatListView}
                renderItem={({ item, index }) => {
                  return (
                    <View>
                      <TouchableOpacity
                        style={styles.faqLinkWidget}
                        onPress={() => toggleExpand(index)}
                      >
                        <Text style={styles.questionText}>
                          <HTMLRenderer html={item.questn} />
                        </Text>

                        <View style={styles.arrowWidget}>
                          {expanded == index ? (
                            <TouchableOpacity onPress={() => setExpanded(null)}>
                              <CImage.ArrowUpIcon></CImage.ArrowUpIcon>
                            </TouchableOpacity>
                          ) : (
                            <TouchableOpacity
                              onPress={() => setExpanded(index)}
                            >
                              <CImage.ArrowDownIcon></CImage.ArrowDownIcon>
                            </TouchableOpacity>
                          )}
                        </View>
                      </TouchableOpacity>
                      {expanded != index ? (
                        <View style={styles.emptyBg} />
                      ) : null}
                      <View style={{}} />
                      {expanded == index && (
                        <View style={{}}>
                          <Text style={styles.answerText}>
                            <HTMLRenderer html={item.answer} />
                          </Text>

                          <View style={styles.emptyBg} />
                        </View>
                      )}
                    </View>
                  );
                }}
              />
            </ScrollView>
          </View>
          <View style={styles.secondViewStyle}>
            <CText.basicInformationSubHeader>
              {" "}
              {"Contact Us"}
            </CText.basicInformationSubHeader>
            <View
              style={[
                styles.gradBoxOne,
                {
                  flexDirection: "row",
                  backgroundImage:
                    "linear-gradient(126deg, #cae7d0 12%, #8ccbba 90%)",
                },
              ]}
            >
              <CImage.FaqCtaImg></CImage.FaqCtaImg>
              <View style={styles.gradBoxOneContent}>
                <View style={styles.gradBoxOneWidget}>
                  <Text
                    style={[
                      styles.gradSubTitle,
                      { color: "#9c1d25", fontFamily: "Inter" },
                    ]}
                  >
                    {"IDFC FIRST BANK LIMITED"}
                  </Text>
                  <Text style={[styles.gradSubTitle, { color: "#010102" }]}>
                    {"GLB Assure 24X7 Helpline"}
                  </Text>
                  <Text
                    style={[
                      styles.gradSubTitle,
                      { color: "#010102", fontSize: 17, marginVertical: 5 },
                    ]}
                  >
                    {"1800-3090-126"}
                  </Text>
                  <Text
                    style={[
                      styles.gradSubTitle,
                      { color: "#010102", marginVertical: 4 },
                    ]}
                  >
                    {"Support@globalassure.com"}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>
        {alertModalVisible && <CDocxViewer type = "FF_PROMAX_TNC" visibility={setAlertModalVisible}/>}
        {loading && <Loader />}
      </View>
    </>
  );
};

// define your styles
const useStyles = CreateResponsiveStyle(
  {
    container: {
      width: "100%",
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
      marginLeft: 20,
      alignItems: "center",
      justifyContent: "center",
    },

    rechargeBody: {
      width: "100%",
      minHeight: 510,
      padding: 20,
      justifyContent: "space-between",
      flexDirection: "row",
    },
    overlayContentStyle: {
      width: "60%",
      height: "90%",
      backgroundColor: "white",
      borderRadius: 15,
    },
    pdfViewStyle: {
      height: "60%",
      width: "100%",
    },

    secondViewStyle: {
      width: "40%",
    },

    firstViewStyle: {
      width: "60%",
      alignItems: "flex-start",
    },
    title: {
      color: "#5a5755",
      fontFamily: "Inter",
      fontSize: 18,
      alignSelf: "center",
      marginTop: 25,
    },
    gradBoxOne: {
      borderRadius: 15,
      overflow: "hidden",
      minHeight: 170,
      maxHeight: 180,
      width: "100%",
      marginVertical: 15,
      backgroundColor: "#e9e9e9",
    },
    gradTitle: {
      color: "#25243b",
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: "700",
    },
    gradSubTitle: {
      color: "#25243b",
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "500",
      marginVertical: 12,
      lineHeight: 20,
    },
    btnWidget: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      marginVertical: 6,
      alignSelf: "flex-end",
    },
    btnYellow: {
      backgroundColor: "#ffdf66",
      borderRadius: 5,
      minWidth: 105,
      padding: 10,
    },
    btnYellowTxt: {
      color: "#25243b",
      fontFamily: "Inter",
      fontSize: 8,
      textTransform: "uppercase",
    },
    flatListView: {
      width: "100%",
      paddingRight: 20,
      height: 550,
    },
    gradBoxOneContent: {
      flex: 1,
      borderRadius: 15,
      paddingRight: 20,
      paddingLeft: 40,
    },
    questionText: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "500",
      letterSpacing: 0,
      textAlign: "left",
      color: "#5f5f5f",
      paddingVertical: 3,
    },
    answerText: {
      fontFamily: "Inter",
      fontSize: 14,
      color: "#686873",
      paddingVertical: 5,
    },
    faqLinkWidget: {
      marginTop: 0,
      flexDirection: "row",
      justifyContent: "space-between",
      paddingVertical: 5,
    },
    emptyBg: {
      width: "100%",
      height: 0.5,
      backgroundColor: "#a0a0a0",
    },
    arrowWidget: {
      alignItems: "center",
      justifyContent: "center",
    },
  },

  {
    [maxSize(DEVICE_SIZES.SM)]: {
      rechargeBody: {
        height: 789,
        flexDirection: "column",
        marginTop: 0,
      },
      firstViewStyle: {
        width: "100%",
      },
      secondViewStyle: {
        width: "100%",
      },
      overlayContentStyle: {
        width: "90%",
      },
      gradBoxOneContent: {
        paddingLeft: 0,
      },
      gradSubTitle: {
        fontSize: 10,
      },
    },

    [maxSize(DEVICE_SIZES.MD)]: {
      container: { paddingLeft: 37.2 },
      rechargeBody: {
        height: 830,
        flexDirection: "column",
        marginTop: 0,
        paddingTop: 5,
        width: "100%",
      },
      firstViewStyle: {
        width: "100%",
        height: "48%",
        flex: 1,
      },
      secondViewStyle: {
        width: "100%",
        height: "48%",
        paddingVertical: 10,
        flex: 1,
      },

      rb1c1: {
        width: "75%",
        alignItems: "flex-start",
      },

      rb1c2: {
        width: "75%",
        justifyContent: "flex-start",
      },
      overlayContentStyle: {
        width: "90%",
      },
    },

    [minSize(DEVICE_SIZES.LG)]: {},
    [DEVICE_SIZES.XS]: {
      container: {
        minWidth: "60vw",
        width: "100%",
        paddingLeft: 0,
      },
      rechargeBody: {
        minWidth: "40vw",
        maxWidth: "90vw",
        height: 909,
        flexDirection: "column",
        marginTop: 0,
        paddingTop: 5,
        width: Dimensions.get("window").width,
        marginHorizontal: 0,
      },
      firstViewStyle: {
        width: "100%",
      },
      secondViewStyle: {
        width: "100%",
      },
      gradBoxOne: {
        height: 161,
        minHeight: 101,
      },
      overlayContentStyle: {
        width: "90%",
      },
      pdfViewStyle: {
        alignItems: null,
      },
      gradBoxOneContent: {
        paddingLeft: 0,
      },
      gradSubTitle: {
        fontSize: 10,
      },
    },
  }
);

//make this component available to the app
export default MPFaq;
